import React from "react";

import Header5 from "../Header/Header8";
import Footer2 from "../Footer/Footer7";
import SimpleSlider2 from "../Sliders/Slick-slider2";
import bg_vide from "../../videos/A4H501C4.mp4";

function A4HFIRST() {
  return (
    <>
    
      <style>{`
        body, html {
    margin: 0;
    padding: 0;
  }

  .full-screen-block {
  position: relative;
  width: 100%;
  height: auto;
  overflow: visible;
}

.bg_video {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center center;
  display: block;
}

  .hero-header {
    text-align: center;
    padding: 40px 20px;
    background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
    color: #e91f1f;
  }

  .hero-header h1{
    margin: 0;
    margin-bottom: 50px;
    font-size: 32px;
    font-weight: 900;
    letter-spacing: 1px;
  }

  .hero-header p{
  max-width: 1300px;
  margin: 25px auto;
  font-size: 18px;
  line-height: 1.9;
  color: #222;
  font-weight: 500;
  text-align: justify;
  padding: 0 40px;
  box-sizing: border-box;
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
  @media (max-width: 768px) {

  .hero-header {
    padding: 30px 15px;
  }

  .hero-header h1{
    font-size: 18px;
    line-height: 1.2;
  }

  .hero-header h4{
    font-size: 14px;
    line-height: 1.25;
  }

  .hero-header p{
    font-size: 13px !important;
    line-height: 1.4;
    padding: 0 10px;
    text-align: left;
  }

  .section-divider span{
    font-size: 16px;
  }
}
      `}</style>
      

      <div  id="home" className="full-screen-block viewport-video-page"> 
        <video
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          disableRemotePlayback
          className="bg_video"
          onContextMenu={(e) => e.preventDefault()}
        >
                <source src={bg_vide} type="video/mp4"></source>
        </video> 
        
        <Header5/>
        <SimpleSlider2/>
      </div>

      {/* HEADER BELOW VIDEO */}
      <div className="hero-header">
        <h1>Americans4Hindus - 501(C)(4) DAC (Dharma Action Council)</h1>
        <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div> 
          <h4>
            <strong>Advancing Civic Engagement, Public Policy, and Community Advocacy</strong>
          </h4>
        <p>
         The Americans4Hindus Dharma Action Council (A4H DAC) serves as the public policy and advocacy arm of the Americans4Hindus movement. Established as a 501(c)(4) social welfare organization, A4H DAC focuses on legislative engagement, grassroots advocacy, government relations, policy communications, and issue-based initiatives that impact Hindu Americans and allied communities. Through constructive participation in the public policy process, A4H DAC works to ensure that community perspectives are heard, understood, and considered by decision-makers at every level of government.
        </p>
        <p>
          The creation of A4H DAC reflects the growing need for a dedicated advocacy infrastructure capable of addressing policy challenges, supporting civic engagement, and building long-term relationships with policymakers and public institutions. As communities face increasingly complex legislative, regulatory, and societal issues, A4H DAC provides a platform through which individuals, organizations, and community leaders can engage effectively, responsibly, and strategically in public affairs and policy discussions.
        </p>
        <p>
          Through legislative lobbying, grassroots mobilization, government relations programs, public policy communications, research initiatives, and membership-based advocacy networks, A4H DAC transforms community concerns into organized civic action. By empowering informed citizens, developing advocacy leaders, and strengthening public policy engagement, Americans4Hindus Dharma Action Council is helping build a future where Hindu Americans are active participants in shaping the policies that affect their communities and the nation as a whole.
        </p>
      </div>
      <Footer2/>
    </>
  );
}

export default A4HFIRST;
